import React from 'react';

const Disclaimer = () => {
  return (
    <div>
      {/* Hero Section */}
      <section style={{ 
        background: 'var(--bg-secondary)',
        padding: '80px 0',
        borderBottom: '1px solid var(--border-light)'
      }}>
        <div className="container">
          <h1 className="hero-large" style={{ marginBottom: '16px' }}>
            Disclaimer
          </h1>
          <p className="body-regular" style={{ color: 'var(--text-secondary)' }}>
            Last updated: December 2024
          </p>
        </div>
      </section>

      {/* Content Section */}
      <section className="section-padding">
        <div className="container">
          <div style={{ maxWidth: '800px', margin: '0 auto' }}>
            <div style={{ marginBottom: '40px' }}>
              <h2 className="heading-2" style={{ marginBottom: '16px' }}>
                General Information
              </h2>
              <p className="body-regular" style={{ marginBottom: '16px', lineHeight: '1.7' }}>
                The information provided on The Eternal Care website and in our clinic is for general informational purposes only. While we strive to provide accurate and up-to-date information, we make no representations or warranties of any kind, express or implied, about the completeness, accuracy, reliability, or suitability of the information.
              </p>
            </div>

            <div style={{ marginBottom: '40px' }}>
              <h2 className="heading-2" style={{ marginBottom: '16px' }}>
                Medical Disclaimer
              </h2>
              <p className="body-regular" style={{ marginBottom: '16px', lineHeight: '1.7' }}>
                The content on this website is not intended to be a substitute for professional medical advice, diagnosis, or treatment. Always seek the advice of qualified health providers with any questions you may have regarding a medical condition or treatment. Never disregard professional medical advice or delay in seeking it because of information you have read on this website.
              </p>
            </div>

            <div style={{ marginBottom: '40px' }}>
              <h2 className="heading-2" style={{ marginBottom: '16px' }}>
                Treatment Results
              </h2>
              <p className="body-regular" style={{ marginBottom: '16px', lineHeight: '1.7' }}>
                Individual results from dental treatments may vary. The testimonials, before-and-after images, and treatment descriptions on our website represent individual experiences and are not guarantees of future results. Your specific treatment plan and outcomes will depend on your unique dental condition, health status, and adherence to care instructions.
              </p>
            </div>

            <div style={{ marginBottom: '40px' }}>
              <h2 className="heading-2" style={{ marginBottom: '16px' }}>
                External Links
              </h2>
              <p className="body-regular" style={{ marginBottom: '16px', lineHeight: '1.7' }}>
                Our website may contain links to external websites. These links are provided for your convenience, but we have no control over the content of these sites and accept no responsibility for them or for any loss or damage that may arise from your use of them.
              </p>
            </div>

            <div style={{ marginBottom: '40px' }}>
              <h2 className="heading-2" style={{ marginBottom: '16px' }}>
                Professional Licensing
              </h2>
              <p className="body-regular" style={{ marginBottom: '16px', lineHeight: '1.7' }}>
                Dr. Parmila Mahala and all dental professionals at The Eternal Care are licensed and qualified to practice dentistry in India. All treatments are performed in accordance with professional standards and regulations.
              </p>
            </div>

            <div style={{ marginBottom: '40px' }}>
              <h2 className="heading-2" style={{ marginBottom: '16px' }}>
                Emergency Situations
              </h2>
              <p className="body-regular" style={{ marginBottom: '16px', lineHeight: '1.7' }}>
                In case of a dental emergency outside our operating hours, please contact emergency medical services or visit the nearest hospital emergency department. Our emergency contact information is provided for urgent dental matters during business hours only.
              </p>
            </div>

            <div style={{ marginBottom: '40px' }}>
              <h2 className="heading-2" style={{ marginBottom: '16px' }}>
                Changes to Disclaimer
              </h2>
              <p className="body-regular" style={{ marginBottom: '16px', lineHeight: '1.7' }}>
                We reserve the right to update or modify this disclaimer at any time without prior notice. Please review this page periodically for changes.
              </p>
            </div>

            <div>
              <h2 className="heading-2" style={{ marginBottom: '16px' }}>
                Contact Information
              </h2>
              <p className="body-regular" style={{ marginBottom: '16px', lineHeight: '1.7' }}>
                If you have any questions about this disclaimer or any information on our website, please contact us:
              </p>
              <p className="body-regular" style={{ marginBottom: '8px' }}>
                The Eternal Care
              </p>
              <p className="body-regular" style={{ marginBottom: '8px' }}>
                72/30-A Patel Marg, Mansarovar, Jaipur-302020
              </p>
              <p className="body-regular" style={{ marginBottom: '8px' }}>
                Email: theeternalcare@gmail.com
              </p>
              <p className="body-regular">
                Phone: +91 9256480329
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Disclaimer;
